import { ElementFormatType } from "lexical";
import { HeadingTagType } from "@lexical/rich-text";
import { ListType } from "@lexical/list";

import { SyntheticEvent, useRef, useState } from "react";

import { Menu, MenuItem, Button } from "@mui/material";
import KeyboardArrowDownRoundedIcon from '@mui/icons-material/KeyboardArrowDownRounded';

interface MenuDropdownProps {
  menuOptions: MenuToolbarItem[];
  onClick: (identifier: string | HeadingTagType | ElementFormatType) => void;
  dropdDownDirection?: string | null;
  showItemLabel?: boolean;
  selectionValue?: string;
}

interface MenuToolbarItem {
  label?: string;
  identifier: string | HeadingTagType | ElementFormatType | ListType;
  domElement: JSX.Element | string | null;
}

export default function MenuDropdown(props: MenuDropdownProps): JSX.Element {
  const menuRef = useRef<HTMLDivElement | null>(null);
  const allowCloseOnClick = useRef(false);
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  const handleClickMenu = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClickMenuItem = (event: React.MouseEvent<HTMLElement>, index: number) => {
    props.onClick(props.menuOptions[index].identifier);
    setAnchorEl(null);
  };

  const handleCloseMenu = () => {setAnchorEl(null)};

  const handleMouseDown = (event: SyntheticEvent) => {
    const isOutside = menuRef.current === event.target;
    allowCloseOnClick.current = isOutside;
  };

  const handleMouseUp = (event: SyntheticEvent) => {
    if (!allowCloseOnClick.current) {
      return;
    }

    const isOutside = menuRef.current === event.target;
    if (isOutside) {
      handleCloseMenu();
    }
  };

  const getItemIndex = (): number => {
    return props.menuOptions.findIndex(item => item.identifier === props.selectionValue);
  };

  return (
    <>
      <Button
        variant="text"
        color="inherit"
        onClick={handleClickMenu}
        endIcon={<KeyboardArrowDownRoundedIcon />}
      >
        {props.selectionValue === ""
        ? props.menuOptions[0].domElement
        : props.menuOptions[props.menuOptions.findIndex(item => item.identifier === props.selectionValue)]?.domElement}
      </Button>
      <Menu
        ref={menuRef}
        sx={{"& .MuiList-root":
          {
            display: "flex",
            flexDirection: props.dropdDownDirection ? props.dropdDownDirection : "column"
          }}}
        hideBackdrop={true}
        anchorEl={anchorEl}
        open={open}
        onClose={handleCloseMenu}
        onMouseDown={handleMouseDown}
        onMouseUp={handleMouseUp}
      > 
        {props.menuOptions.map((option, index) => (
          <MenuItem
            key={option.identifier}
            onClick={(event: React.MouseEvent<HTMLLIElement, MouseEvent>) => handleClickMenuItem(event, index)}
            selected={index === getItemIndex()}
          >{option.domElement} {props.showItemLabel && <span style={{marginLeft: "5px"}}>{option.label}</span>}
          </MenuItem>
        ))}
      </Menu>
    </>
  )
}